import {
    GET_APPS,
    GET_APPS_SUCCESS,
    GET_APPS_ERROR,
} from '../constants/appsConstants';

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function appsReducer(state = initialState, action){
    switch (action.type) {
        case GET_APPS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'APPS',
                'loadingMessage': 'THE APPS ARE BEING LOADED',
                'type': action.type
            });
        case GET_APPS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_APPS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'appsData': action.data,
                'type': action.type
            });
        default:
            return state;
    }
};

export default appsReducer